import axios from "../../../../utils/request"

function GET_LIST(params) {
    return axios.get("/template/ATemplate/index", {
        params: {
            ...params
        }
    } )
}
function ADD_DATA(params) {
    return  axios.get("/template/ATemplate/add",{
        params: {}
    } )
}
function EDIT_DATA(params) {
    return  axios.get("/template/ATemplate/edit",{
        params: {id:params}
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/template/ATemplate/addPost",{...params} )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/template/ATemplate/editPost",{...params} )
}


function CHANG_STATUS (params) {
    return  axios.post("/template/ATemplate/listOrder",{list_orders:params} )
}
function DELE(params) {
    return  axios.get("/template/ATemplate/delete",{
        params: {
            ids:params
        }
    } )
}


function GETTEMPLATECONTENT(params) {
    return  axios.get("/template/ATemplate/templateContent",{     params: {
            id:params
        }
    } )
}

function GETTEMPLATECONTENTPOST(params) {
    return  axios.post("/template/ATemplate/templateContentPost",  {...params}
  )
}
function CHANG_STATUS_MESSAGE(params) {
    return  axios.post("/template/ATemplate/statusEdit",{status:params} )
}
function CHANG_STATUS_PROXY(params) {
    return  axios.post("/template/ATemplate/proxyEdit",{is_proxy:params} )
}function EDIT_STATUS(params) {
    return  axios.post("/template/ATemplate/editStatus",{...params} )
}
function EXPORT(params) {
    return axios.get("/template/ATemplate/exportTemplate", {
        params: {
            ...params
        }
    })
}
export default {
    GET_LIST,
    ADD_DATA,
    EDIT_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    CHANG_STATUS,
    CHANG_STATUS_MESSAGE,
    DELE,
    GETTEMPLATECONTENT,EDIT_STATUS,
    GETTEMPLATECONTENTPOST,CHANG_STATUS_PROXY,EXPORT
}
